import moment from 'moment';
import React, { useState } from 'react';

import DateSelectRange from '../../elements/DateSelectRange';
import ShowMetrics, { TYPE_METRICS, TimeRangeName } from '../../helpers/ShowMetrics';

function DepositMetrics() {
    const url = '/crea/api/metrics';
    const [range, setRange] = useState<TimeRangeName>('last-week');
    const [startDate, setStartDate] = useState(moment().subtract(1, 'weeks').startOf('isoWeek'));
    const [endDate, setEndDate] = useState(moment().subtract(1, 'weeks').endOf('isoWeek'));
    const timeRange = { range, startDate, endDate };

    return (
        <>
            <div className="row no-gutters">
                <div className="dashboard_date-select">
                    <DateSelectRange
                        range={range}
                        setRange={setRange}
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                    />
                </div>
            </div>
            <div className="row metrics">
                <ShowMetrics
                    url={url}
                    path="deposit/new"
                    label="New Deposits"
                    typeMetrics={TYPE_METRICS.VALUE_METRIC}
                    timeRange={timeRange}
                />
                <ShowMetrics
                    url={url}
                    path="deposit/sum"
                    label="Sum of Deposits"
                    typeMetrics={TYPE_METRICS.TREND_METRIC}
                    timeRange={timeRange}
                />
                <ShowMetrics
                    url={url}
                    path="deposit/payment_cost"
                    label="Sum of Deposits (User fee)"
                    typeMetrics={TYPE_METRICS.VALUE_METRIC}
                    timeRange={timeRange}
                />
                <ShowMetrics
                    url={url}
                    path="deposit/per_day"
                    label="Deposits per Day"
                    typeMetrics={TYPE_METRICS.TREND_METRIC}
                    timeRange={timeRange}
                />
                <ShowMetrics
                    url={url}
                    path="deposit/by_payment_method"
                    label="Deposits by Payment Method"
                    typeMetrics={TYPE_METRICS.PARTITION_METRIC}
                    tooltip="Total count of confirmed deposits (Count of <em>Deposit</em> group by <em>Payment Method</em> by <em>Created At</em>)."
                    timeRange={timeRange}
                />
            </div>
        </>
    );
}

export default DepositMetrics;
